import axios from 'axios';
import Helpers from 'utils/helpers';

async function getSoftwareTypes() {
  const url = 'SoftwareUpdate/SoftwareTypes';
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getSoftwareVersions(isForUpdate) {
  const url = `SoftwareUpdate/SoftwareTypeVersions${isForUpdate ? 'ForUpdate' : ''}`;
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getSoftwareUpdateStatuses() {
  const url = 'SoftwareUpdate/SoftwareUpdateStatuses';
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getSoftwareUpdateDetailsStatuses() {
  const url = 'SoftwareUpdate/SoftwareUpdateDetailsStatuses';
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getSoftwareUpdates(filters) {
  const url = 'SoftwareUpdate';
  const request = {
    method: 'GET',
    url: url,
    params: filters,
  };
  const res = await axios(request);
  return res.data;
}

async function getSoftwareUpdateDetails(softwareUpdateId) {
  const url = `SoftwareUpdate/${softwareUpdateId}`;
  const request = {
    method: 'GET',
    url: url,
  };
  const res = await axios(request);
  return res.data;
}

async function insertSoftwareUpdate({
  softwareUpdateName,
  softwareVersionId,
  distributeDateTime,
  siteIds,
  distributeAsap,
  distributeOnHold,
  updateRateVolume,
  updateRateFrequency,
  distributeOptionCode,
}) {
  const url = 'SoftwareUpdate';
  const utcDistrivbuteDateTimeOffset = Helpers.Date.toApiDateTimeObject(distributeDateTime);
  const request = {
    method: 'POST',
    url: url,
    data: {
      softwareUpdateName,
      softwareVersionId,
      distributeDateTime: utcDistrivbuteDateTimeOffset,
      siteIds,
      distributeAsap,
      distributeOnHold,
      updateRateVolume,
      updateRateFrequency,
      distributeOptionCode,
    }
  };
  const res = await axios(request);
  return res.data;
}

async function updateSoftwareUpdate({
  softwareUpdateId,
  softwareUpdateName,
  softwareVersionId,
  distributeDateTime,
  siteIds,
  sitesChanged,
  distributeAsap,
  distributeOnHold,
  updateRateVolume,
  updateRateFrequency,
  distributeOptionCode,
}) {
  const url = `SoftwareUpdate/${softwareUpdateId}`;
  const utcDistrivbuteDateTimeOffset = Helpers.Date.toApiDateTimeObject(distributeDateTime);
  const request = {
    method: 'PUT',
    url: url,
    data: {
      softwareUpdateName,
      softwareVersionId,
      distributeDateTime: utcDistrivbuteDateTimeOffset,
      siteIds,
      sitesChanged,
      distributeAsap,
      distributeOnHold,
      updateRateVolume,
      updateRateFrequency,
      distributeOptionCode,
    }
  };
  const res = await axios(request);
  return res.data;
}

async function cancelSoftwareUpdate(softwareUpdateId) {
  const url = `SoftwareUpdate/cancelUpdate/${softwareUpdateId}`;
  const request = {
    method: 'POST',
    url: url,
  };
  const res = await axios(request);
  return res.data;
}

async function deleteSoftwareUpdate(softwareUpdateId) {
  const url = `SoftwareUpdate/deleteUpdate/${softwareUpdateId}`;
  const request = {
    method: 'POST',
    url: url,
  };
  const res = await axios(request);
  return res.data;
}

async function cancelDestination(softwareUpdateDetailId) {
  const url = `SoftwareUpdate/cancelUpdateDestination/${softwareUpdateDetailId}`;
  const request = {
    method: 'POST',
    url: url,
  };
  const res = await axios(request);
  return res.data;
}

async function deleteDestination(softwareUpdateDetailId) {
  const url = `SoftwareUpdate/deleteUpdateDestination/${softwareUpdateDetailId}`;
  const request = {
    method: 'POST',
    url: url,
  };
  const res = await axios(request);
  return res.data;
}

async function retryDestination(softwareUpdateDetailId) {
  const url = `SoftwareUpdate/retryUpdateDestination/${softwareUpdateDetailId}`;
  const request = {
    method: 'POST',
    url: url,
  };
  const res = await axios(request);
  return res.data;
}

async function getLogForDestination(softwareUpdateDetailId) {
  const url = `SoftwareUpdate/getLogForUpdateDestination/${softwareUpdateDetailId}`;
  const request = {
    method: 'GET',
    url: url
  };
  const res = await axios(request);
  return res.data;
}

async function getSoftwareUpdateManifestById(id) {
  const url = `SoftwareUpdate/Manifest/${id}`;
  const request = {
    method: 'GET',
    url: url,
  };
  const res = await axios(request);
  return res.data;
}

async function getSoftwareUpdateDashboard(data) {
  const url = `SoftwareUpdate/Dashboard`;
  const request = {
    method: 'POST',
    url: url,
    data,
  };
  const res = await axios(request);
  return res.data;
}




const SoftwareUpdateService = {
  API: {
    getSoftwareTypes,
    getSoftwareVersions,
    getSoftwareUpdateStatuses,
    getSoftwareUpdateDetailsStatuses,
    getSoftwareUpdates,
    getSoftwareUpdateDetails,
    insertSoftwareUpdate,
    updateSoftwareUpdate,
    cancelSoftwareUpdate,
    deleteSoftwareUpdate,
    cancelDestination,
    deleteDestination,
    retryDestination,
    getLogForDestination,
    getSoftwareUpdateManifestById,
    getSoftwareUpdateDashboard,
  },
};

export default SoftwareUpdateService;